<div>
  <ul id="previewLastMessages" #goToLastMessage>
    <li
      *ngFor="let chatMessage of chat.messages; let last = last"
      class="chat-msg-height"
      [ngClass]="{ 'chat-message': chatMessage.type === 'CHAT' || chatMessage.type === 'FILE' }"
    >
      <div *ngIf="chatMessage.type === 'CHAT' || chatMessage.type === 'FILE'">
        <div class="chat-message-content clearfix">
          <div class="interlocutor-fullName">
            <span *ngIf="chatMessage.isFromCustomer()">
              <span *ngIf="chat.tab.chatName">{{ chat.tab.chatName | translate }}</span>
              <span *ngIf="!chat.tab.chatName">{{ 'agent:contact.info.unknown_contact' | translate | uppercase }}</span>
            </span>
            <span *ngIf="chatMessage.isFromRealAgent() && chatMessage.csrId === csrId">
              {{ 'agent:contact.info.me' | translate }}
            </span>
            <span *ngIf="chatMessage.isFromRealAgent() && chatMessage.csrId !== csrId">
              {{ chatMessage.firstName }} {{ chatMessage.lastName }}
            </span>
            <span *ngIf="chatMessage.isFromBot()">
              {{ chatMessage.firstName }}
            </span>
          </div>

          <time class="chat-time">{{ chatMessage.date | localizedDate: 'HH:mm' }}</time>

          <div *ngIf="!chatMessage.isFromCustomer() && chatMessage.type !== 'FILE'">
            <p [innerHTML]="getUrl(getMessageContent(chatMessage))" class="contentMsgChat"></p>
          </div>

          <div *ngIf="chatMessage.isFromCustomer()">
            <p [innerHTML]="getMessageContent(chatMessage)" class="contentMsgChat"></p>
          </div>

          <div *ngIf="chatMessage.chatbotExchangeMessage && chatMessage.chatbotExchangeMessage.imageUrl">
            <img
              class="bot-message-picture"
              [src]="chatMessage.chatbotExchangeMessage.imageUrl"
              alt="{{ 'agent:basic.bot_picture' | translate }}"
            />
          </div>

          <div
            *ngIf="
              chatMessage.chatbotExchangeMessage &&
              !chatMessage.chatbotExchangeMessage.imageUrl &&
              chatMessage.chatbotExchangeMessage.attachment
            "
          >
            <div class="attachment">
              <chat-attachment
                [filename]="chatMessage.chatbotExchangeMessage.attachment.name"
                [size]="chatMessage.chatbotExchangeMessage.attachment.size"
              ></chat-attachment>
              <div class="error-message" *ngIf="errorMessage">
                {{ 'agent:panel.chat.attachment.' + errorMessage | translate }}
              </div>
            </div>
          </div>

          <div *ngIf="chatMessage.type === 'FILE'">
            <div class="attachment">
              <a (click)="downloadFile()">
                <chat-attachment [filename]="chatMessage.attachment.fileName" [size]="chatMessage.attachment.fileSize"> </chat-attachment>
              </a>
              <div class="error-message" *ngIf="errorMessage">
                {{ 'agent:panel.chat.attachment.' + errorMessage | translate }}
              </div>
            </div>
          </div>
        </div>
      </div>
      {{ last ? scrollToBottom(chat) : '' }}
      {{ last ? scrollMessageToBottom() : '' }}
    </li>
  </ul>
</div>
